import * as auth from './auth'
import * as sale from './sale'
import * as users from './users'

export default {
  auth,
  sale,
  users,
}
